/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-useless-catch */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable consistent-return */
import Keycloak from 'keycloak-js';
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';

import { useStoreActions } from './reducers';
import { User } from './types';

// TODO (mw) silenced an error here that keycloak context changes every render. revisit
interface KeycloakContextProps {
  keycloak: Keycloak | null;
  authenticateUserWithEmailPass: (
    username: string,
    password: string
  ) => Promise<void>;
  refreshKeycloakToken: () => Promise<void>;
}

const KeycloakContext = createContext<KeycloakContextProps>({
  keycloak: null,
  authenticateUserWithEmailPass: async () => {},
  refreshKeycloakToken: async () => {},
});

const keycloakConfig = {
  // Your Keycloak configuration
  realm: `${process.env.REACT_APP_KEYCLOAK_REALM}`,
  url: `${process.env.REACT_APP_KEYCLOAK_BASE_URL}`,
  clientId: `${process.env.REACT_APP_KEYCLOAK_CLIENT_ID}`,
  scope: 'openid',
};

function getUserInfo(keycloak: Keycloak): User | undefined {
  if (keycloak.authenticated && keycloak.idTokenParsed && keycloak.token) {
    const userInfo: User = {
      name: keycloak.idTokenParsed.name,
      email: keycloak.idTokenParsed.email,
      accessToken: keycloak.token,
      identity_id: keycloak.idTokenParsed.sub || '',
    };
    return userInfo;
  }
}

function setLocalStorageTokens(keycloak: Keycloak) {
  if (keycloak) {
    localStorage.setItem('kcRefreshToken', keycloak.refreshToken ?? '');
    localStorage.setItem('kctoken', keycloak.token ?? '');
  }
}

export const KeycloakProvider: React.FC = ({ children }) => {
  const { setUser, setIsAuthenticated } = useStoreActions((actions) => ({
    ...actions.user,
  }));
  const [keycloak, setKeycloak] = useState<Keycloak | null>(null);
  const location = useLocation();

  const initKeycloak = useCallback(async () => {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const keycloak = new Keycloak(keycloakConfig);
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    keycloak.onTokenExpired = async () => {
      // if user is offline, the app will not refresh token
      // console.log('navigator.onLine: ', navigator.onLine);
      if (!navigator.onLine) return;

      try {
        await keycloak.updateToken(30);
        if (keycloak) {
          const userInfo = getUserInfo(keycloak);
          if (userInfo) {
            setUser(userInfo);
          }
          setLocalStorageTokens(keycloak);
        }
      } catch (error) {
        console.error(
          'Keycloak refresh failed while user is online, log user out.'
        );
        // we can't update keycloak token while user is online, sign user out and redirect to login page
        localStorage.removeItem('kcRefreshToken');
        localStorage.removeItem('kctoken');
        await keycloak?.logout({
          redirectUri: `${window.location.origin}/login`,
        });
      }
    };

    keycloak.onAuthLogout = () => {
      localStorage.removeItem('kcRefreshToken');
      localStorage.removeItem('kctoken');
      /* 
        When user on login page, we don't want to redirect to login page again cause the lost of error message
      */
      if (location.pathname !== '/login' && location.pathname !== '/register') {
        keycloak?.logout({
          redirectUri: `${window.location.origin}/login`,
        });
      }
    };

    keycloak.onAuthSuccess = () => {
      setLocalStorageTokens(keycloak);
    };

    const refreshToken = localStorage.getItem('kcRefreshToken');
    const kctoken = localStorage.getItem('kctoken');

    const initOptions: Keycloak.KeycloakInitOptions = {
      enableLogging: false,
      messageReceiveTimeout: 100000,
      pkceMethod: 'S256',
    };

    try {
      await keycloak.init(initOptions);
      if (refreshToken && kctoken) {
        keycloak.sessionId = undefined;
        keycloak.token = kctoken;
        keycloak.refreshToken = refreshToken;

        try {
          await keycloak.updateToken(1);
        } catch (error) {
          localStorage.removeItem('kcRefreshToken');
          localStorage.removeItem('kctoken');
        }
      }
    } catch (error) {
      console.error('Error initializing keycloak ');
    }

    setKeycloak(keycloak);
  }, [location.pathname, setUser]);

  useEffect(() => {
    const isSharedDrive = location.pathname.includes('/share/');
    // We run this if keycloak was not initialized
    // We do not run this if the drive is shared which is defined here based on URL
    if (!keycloak && !isSharedDrive) {
      initKeycloak();
    }
  }, [keycloak, initKeycloak, location]);

  useEffect(() => {
    // Additional actions to perform after Keycloak initialization
    if (keycloak) {
      const userInfo = getUserInfo(keycloak);
      if (userInfo) {
        setIsAuthenticated(true);
        setUser(userInfo);
      }
    }
  }, [keycloak, setUser, setIsAuthenticated]);

  const authenticateUserWithEmailPass = async (
    username: string,
    password: string
  ): Promise<void> => {
    try {
      const tokenEndpoint = `${keycloakConfig.url}/realms/${keycloakConfig.realm}/protocol/openid-connect/token`;
      const formData = new URLSearchParams();
      formData.append('grant_type', 'password');
      formData.append('scope', 'openid');
      formData.append('client_id', keycloakConfig.clientId);
      formData.append('username', username);
      formData.append('password', password);

      const response = await fetch(tokenEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData,
      });

      if (!response.ok) {
        const json = await response.json();
        throw new Error(
          `Failed to authenticate user: ${json.error_description}`
        );
      }

      const responseData = await response.json();

      localStorage.setItem('kcRefreshToken', responseData.refresh_token ?? '');
      localStorage.setItem('kctoken', responseData.access_token ?? '');
      sessionStorage.setItem('user-email', username);

      if (keycloak) {
        /*
          use the token got from endpoint to re-initialize keycloak instance
        */
        keycloak.sessionId = undefined;
        keycloak.token = responseData.access_token;
        keycloak.refreshToken = responseData.refresh_token;
        try {
          await keycloak.updateToken(-1);

          const userInfo = getUserInfo(keycloak);
          if (userInfo) {
            setIsAuthenticated(true);
            setUser(userInfo);
            setLocalStorageTokens(keycloak);
          }
        } catch (error) {
          console.error('fail to update token');
        }
      }
    } catch (error) {
      throw error;
    }
  };

  const refreshKeycloakToken = useCallback(async () => {
    if (!navigator.onLine) return;
    if (keycloak) {
      try {
        await keycloak.updateToken(30);
        if (keycloak) {
          const userInfo = getUserInfo(keycloak);
          if (userInfo) {
            setUser(userInfo);
          }
          setLocalStorageTokens(keycloak);
        }
      } catch (error) {
        console.error(
          'Keycloak auto refresh failed when window gain focus but token expired.'
        );
        localStorage.removeItem('kcRefreshToken');
        localStorage.removeItem('kctoken');
        await keycloak?.logout({
          redirectUri: `${window.location.origin}/login`,
        });
      }
    }
  }, [keycloak, setUser]);

  return (
    <KeycloakContext.Provider
      value={{
        keycloak,
        authenticateUserWithEmailPass,
        refreshKeycloakToken,
      }}
    >
      {children}
    </KeycloakContext.Provider>
  );
};

export const useKeycloak = (): KeycloakContextProps =>
  useContext(KeycloakContext);
